import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { PaymentItem } from './payment-item.model';
import { PaymentItemPopupService } from './payment-item-popup.service';
import { PaymentItemService } from './payment-item.service';
import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';
import { CRUD_ACTIONS } from '../../shared';

@Component({
    selector: 'jhi-payment-item-delete-dialog',
    templateUrl: './payment-item-delete-dialog.component.html'
})
export class PaymentItemDeleteDialogComponent {

    paymentItem: PaymentItem;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private paymentItemService: PaymentItemService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(studentGlobalLocations);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.paymentItemService.delete(id)
        .subscribe((response) => {
            this.eventManager.broadcast({
                name: 'paymentItemListModification',
                content: {
                    action: CRUD_ACTIONS.DELETE,
                    content: {id: id}
                }
            });

            // TODO  if the payment was deleted and the user is on the payment screen, add a label to the modal :
            // the payment was deleted, add a button to go to home page
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-payment-item-delete-popup',
    template: ''
})
export class PaymentItemDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private paymentItemPopupService: PaymentItemPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.paymentItemPopupService
                .open(PaymentItemDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment-item/payment-item-delete-dialog.component.ts